/**
 * Custom Notification Component
 *
 * Simple wrapper around react-admin's Notification.
 * Styling is handled via GlobalStyles in App.tsx and styles.css
 */
import { Notification } from 'react-admin';

/**
 * CustomNotification - react-admin Notification wrapper
 *
 * This is a simple passthrough component. All styling is handled
 * via global CSS to ensure portal-rendered notifications are styled correctly.
 */
const CustomNotification = () => {
  return <Notification />;
};

export default CustomNotification;
